<div class="">
  <div class="">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Update Route?</h4>
      </div>
      <div class="modal-body">
        <div class="card">
          <div class="card-body p-0">
            <div
              class="d-flex flex-column justify-content-center"
              *ngIf="loading"
            >
              <app-spinner></app-spinner>
            </div>
            <div
              class="alert alert-danger fade show"
              role="alert"
              *ngIf="errorMessage !== ''"
            >
              <i class="material-icons alert-icon">error</i>
              <div>{{ errorMessage }}</div>
              <button type="button" class="close" data-dismiss="alert">
                <i class="modus-icon material-icons">close</i>
              </button>
            </div>
            <div *ngIf="errorMessage === ''">
              <label for="txtName" class="font-weight-bold">Route Name</label>
              <input
                #name
                class="form-control"
                id="txtName"
                type="text"
                name="updateRouteName"
                [(ngModel)]="updateRouteName"
                (keydown.enter)="keydownEvent($event)"
              />
              {{ textMessage }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          (click)="updateRouteModalRef.hide()"
          class="btn btn-outline-dark"
        >
          No
        </button>
        <button
          [disabled]="errorMessage !== ''"
          (click)="updateRoute()"
          class="btn btn-primary"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
